/** Aligné sur backend/services/b2b/b2bClientAccess.js */

export function canManageB2bClients(user) {
  if (!user) return false;
  const role = String(user.role || '').toUpperCase();
  if (role === 'SUPER_ADMIN' || role === 'ADMIN') return true;
  if (role !== 'COMMERCANT') return false;
  const interne = user.roleInterne || null;
  if (!interne) return true;
  return interne === 'GERANT' || interne === 'MANAGER';
}
